/**
 * Generates a deterministic, visually-distinct HSL color from any string.
 * Used for coins not in the hardcoded SUPPORTED_COINS list.
 */
export function hashColor(str: string): string {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash |= 0;
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 60%, 55%)`;
}
